var React = require('react');

function NavIconsSecurity (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#231f20;}")),React.createElement("title",{"key":1},"nav-icons_security"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M12,33.36H8.29V20.41C8.29,8.77,16.11,0,26.47,0S44.64,8.77,44.64,20.41V32.83H40.91V20.41c0-9.66-6.07-16.68-14.44-16.68S12,10.75,12,20.41Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M52.94,69.63H0V30.45H52.94ZM3.73,65.9H49.2V34.18H3.73Z","key":1}),React.createElement("rect",{"className":"cls-1","x":"1.87","y":"55.82","width":"49.2","height":"3.73","key":2})]))]);
}

NavIconsSecurity.defaultProps = {"viewBox":"0 0 52.94 69.63"};

module.exports = NavIconsSecurity;

NavIconsSecurity.default = NavIconsSecurity;
